export const REPORTING = 'reporting-read';
export const CLIENT_USERS = 'client_users-read';
export const CLIENT_PROJECTS = 'client_projects-read';
export const CLIENT_CASES = 'client_cases-read';
export const CLIENT_CASES_UPDATE = 'client_cases-update';
export const APPROVALS = 'approvals-read';
export const TESTING = 'testing-read';
